





















import { Component, Emit, Watch } from "vue-property-decorator";
import Vue from "vue";
import 'vue-slider-component/theme/default.css'
import ScoringKeyEditor from "./ScoringKeyEditor.vue";
import { getModule } from "vuex-module-decorators";
import Dialogs from "@/store/modules/Dialogs";
import ScoringKeys, { ScoringKeyDefinition } from "@/store/modules/ScoringKeys";
import Viewpoints from "@/store/modules/Viewpoints";
import Decisions from "@/store/modules/Decisions";
import { NotificationEventBus } from "@/EventBus";
import Modelling from "@/store/modules/Modelling";

const dialogsModule = getModule(Dialogs)
const viewpointsModule = getModule(Viewpoints)
const decisionsModule = getModule(Decisions)
const scoringKeysModule = getModule(ScoringKeys)
const modellingModule = getModule(Modelling)
@Component({
    components: {ScoringKeyEditor}
})
export default class ScoringKeyEditorVuexDialog extends Vue {

    private scoringKeyDialog = false;
    private processing = false;

    @Watch('factorGroupId')
    @Watch('viewpointId')
    private onIdChanges() {
        if (this.factorGroupId && this.viewpointId) {
            this.scoringKeyDialog = true;
        } else {
            this.scoringKeyDialog = false;
        }
    }

    get selectedResource() {
        return dialogsModule.selectedScoringKeyEdit
    }

    get viewpointId() {
        if (!this.selectedResource) return;
        return this.selectedResource.viewpointId
    }

    get factorGroupId() {
        if (!this.selectedResource) return;
        return this.selectedResource.resourceId
    }

    get resource() {
        if (!this.factorGroupId || !this.viewpointId) return;
        return modellingModule.publishedModelFactorResources[this.factorGroupId]
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get scoringKeyDefinitions() {
        return scoringKeysModule.viewpointScoringKeyDefinitions;
    }

    get defaultScoringKeyDefinition() {
        if (this.scoringKeyDefinitions && this.factorGroupId && this.viewpointId) {
            return this.scoringKeyDefinitions[this.viewpointId][this.factorGroupId]
        }
    }

    get scoringKeys() {
        if (this.defaultScoringKeyDefinition) {
            return this.defaultScoringKeyDefinition.scoringKeys
        }
    }

    get inheritedFromName() {
        if (!this.defaultScoringKeyDefinition || !this.defaultScoringKeyDefinition.inheritedFrom || !this.viewpointId || !this.factorGroupId) {
            return;
        }
        let inheritedFrom = this.defaultScoringKeyDefinition.inheritedFrom;
        let inheritedFromResourceId = this.defaultScoringKeyDefinition.inheritedFromResourceId

        if(inheritedFromResourceId && inheritedFromResourceId != "M") {
            return `GROUP (${this.factorResources[inheritedFromResourceId].name})`
        }
        if (inheritedFrom === 'VIEWPOINT' && viewpointsModule.selectedViewpointsMap && viewpointsModule.selectedViewpointsMap[this.viewpointId]) {
            return `Viewpoint (${viewpointsModule.selectedViewpointsMap[this.viewpointId].name})`;
        } else if (inheritedFrom === 'DECISION' && decisionsModule.selectedDecision) {
            return `Decision (${decisionsModule.selectedDecision.name})`
        } else if (inheritedFromResourceId) {
            return `Section (${modellingModule.publishedModelFactorResources[inheritedFromResourceId].name})`;
        }
    }


    @Emit()
    private async submit(scoringKeys: any[]) {
        await this.updateScoringKeys(scoringKeys);
    }

    @Emit('delete')
    private async deleteClick() {
        await this.updateScoringKeys(null);
    }

    private async updateScoringKeys(scoringKeys: any[] | null) {
        if (!this.viewpointId || !this.factorGroupId || !this.resource) return;
        let scoringKeyDefinition: ScoringKeyDefinition | undefined;
        if (scoringKeys == null || scoringKeys.length === 0) {
            scoringKeyDefinition = undefined;
        } else {
            scoringKeyDefinition = {
                scoringKeys: scoringKeys,
                notApplicableEnabled: false
            }
        }

        let payload = {
            viewpointId: this.viewpointId,
            factorResourceId: this.factorGroupId,
            scoringKeyDefinition: scoringKeyDefinition
        }

        try {
            this.processing = true;
            await scoringKeysModule.updateViewpointFactorResourceScoringKeyDefinition(payload)
        } catch (e) {
            NotificationEventBus.emitFailedMessage(e)
        }
        this.processing = false;
        await dialogsModule.editScoringKey(null)
    }

    @Emit('cancel')
    private cancel() {
        this.scoringKeyDialog = false;
        dialogsModule.editScoringKey(null)
    }
}
